import _ from 'lodash';
import {
  INTENT_TYPES,
  QUICK_ADJUSTMENT_ACTIONS,
  QUICK_ADJUSTMENT_TRIGGERS,
} from 'v2/common/constants/index';
import { buildLegProperty } from './config';
import { isCaseBasedAction } from 'v2/modules/withRunForm/components/Intents/Intent/OpenLegIntent/QuickAdjustments/Utils';

const intentTypeFor = (action) => {
  switch (action) {
    case QUICK_ADJUSTMENT_ACTIONS.CloseLeg.value:
      return INTENT_TYPES.CloseLeg;
    case QUICK_ADJUSTMENT_ACTIONS.ExecuteLeg.value:
      return INTENT_TYPES.ExecuteLeg;
    case QUICK_ADJUSTMENT_ACTIONS.OpenCase.value:
      return INTENT_TYPES.OpenCase;
    case QUICK_ADJUSTMENT_ACTIONS.CloseCase.value:
      return INTENT_TYPES.CloseCase;
    default:
      return INTENT_TYPES.UpdateStopLoss;
  }
};

const intentsFor = (action, targets, labelToReferenceMap) => {
  const isCaseBased = isCaseBasedAction(action);
  const intentType = intentTypeFor(action);

  return _.flatMap(targets, (target) => {
    if (isCaseBased) {
      return {
        type: intentType,
        caseIndex: target
      };
    }

    return _.chain(labelToReferenceMap)
      .filter((_, key) => key === target || key.startsWith(`${target}(`))
      .map((ref) => ({
        type: intentType,
        target: ref
      }))
      .value();
  });
}


const signalFor = (label, trigger, delayBy, labelToReferenceMap) => {
  const reference = labelToReferenceMap[label];
  const property = trigger === QUICK_ADJUSTMENT_TRIGGERS.ExitedInLoss.value
    ? 'hasExitedInLoss'
    : 'hasExitedInProfit';
  const signal = [
    {
      conditionOperator: '',
      leftOperand: buildLegProperty(reference, property),
      operator: 'equalTo',
      rightOperand: '1',
    },
  ];

  if (_.isNumber(delayBy)) {
    signal.push({
      conditionOperator: 'and',
      leftOperand: buildLegProperty(reference, 'exitTimeFromNow'),
      operator: 'equalOrAbove',
      rightOperand: `${delayBy || 0}seconds`,
    });
  }
  return signal;
};

const adjustmentsForQuickAdjustments = (
  label,
  quickAdjustments,
  labelToReferenceMap
) => {
  return _.chain(quickAdjustments)
    .groupBy((qa) => `${qa.trigger}-${qa.delayBy}`)
    .map((similarQuickAdjustments) => {
      const { trigger, delayBy } = similarQuickAdjustments[0] || {};
      return {
        uiConfigs: {
          isAutoAdjustment: true,
          adjustmentMode: 'quickAdjustment',
        },
        signal: signalFor(label, trigger, delayBy, labelToReferenceMap),
        intents: _.flatMap(similarQuickAdjustments, ({ action, targets }) => {
          return intentsFor(action, targets, labelToReferenceMap);
        }),
      };
    })
    .value();
};

export const getSyntheticAdjustments = (allIntents) => {
  const labelToReferenceMap = _.reduce(
    allIntents,
    (hsh, intent) => {
      if (intent?.type === INTENT_TYPES.OpenLeg && intent?.identifier?.label) {
        hsh[intent?.identifier?.label] = intent?.identifier;
      }
      return hsh;
    },
    {}
  );

  return _.flatMap(allIntents, (intent) => {
    const quickAdjustments = intent?.uiConfigs?.quickAdjustments || [];
    const label = intent?.identifier?.label;
    if (quickAdjustments.length <= 0 || _.isUndefined(label)) {
      return [];
    }
    return adjustmentsForQuickAdjustments(
      label,
      quickAdjustments,
      labelToReferenceMap
    );
  });
};
